/*
 * @Author: your name
 * @Date: 2020-07-13 11:13:02
 * @LastEditTime: 2020-09-25 17:52:35
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /shop-cloud-private-web/src/router/index.js
 */
/*
 * @Author: shuSheng
 * @Date: 2019-08-10 09:35:48
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-08-06 15:07:57
 * @Descripttion: 路由
 */
import Vue from 'vue'
import Router from 'vue-router'
import TasteIndex from '@comp/taste/taste-index'
import Customization from '@comp/taste/customization/customization'
import History from '@comp/taste/history/history'
import QRCode from '@comp/QRCode/QRCode'
import ShareSelect from '@comp/share/share-select'
import Share from '@comp/share/share/share'
import Introduce from '@comp/share/share/introduce'
import Editor from '@comp/share/editor/editor'
import Collect from '@comp/share/collect/collect'
const ShareSelectNew = resolve => require(['@comp/share/shareSelectNew'], resolve)
const ShareSelect_new = resolve => require(['@comp/share/shareSelect_new'], resolve)
const Share_detail = resolve => require(['@comp/share/share_detail'], resolve)
const Share_middle = resolve => require(['@comp/share/share_middle'], resolve)
const beforeShare = resolve => require(['@comp/share/beforeShare'], resolve)
const CustomizationNew = resolve => require(['@comp/taste/customization/customizationNew'], resolve)


/* 内嵌ipad等路由 */
// import HistoryDiscount from '@comp/historyDiscount/components/historyDiscount'
// import TemporaryPromotion from '@comp/temporaryPromotion/components/temporaryPromotion'
// import Announcement from '@comp/ipadPage/announcement/components/announcement'
// import MemberNotice from '@comp/ipadPage/memberNotice/components/memberNotice'
// import PrivacyPolicy from '@comp/ipadPage/privacyPolicy/components/privacyPolicy'
const HistoryDiscount = resolve => require(['@comp/historyDiscount/components/historyDiscount'], resolve)
const TemporaryPromotion = resolve => require(['@comp/temporaryPromotion/components/temporaryPromotion'], resolve)
const Announcement = resolve => require(['@comp/ipadPage/announcement/components/announcement'], resolve)
const MemberNotice = resolve => require(['@comp/ipadPage/memberNotice/components/memberNotice'], resolve)
const MemberNoticeNew = resolve => require(['@comp/ipadPage/memberNotice/components/memberNoticeNew'], resolve)
const MemberNoticeNewHw = resolve => require(['@comp/ipadPage/memberNotice/components/memberNoticeNewHw'], resolve)
const PrivacyPolicy = resolve => require(['@comp/ipadPage/privacyPolicy/components/privacyPolicy'], resolve)
const PrivacyPolicyNew = resolve => require(['@comp/ipadPage/privacyPolicy/components/privacyPolicyNew'], resolve)
const PrivacyPolicyNewHw = resolve => require(['@comp/ipadPage/privacyPolicy/components/privacyPolicyNewHw'], resolve)
const SoftwareAgreement = resolve => require(['@comp/ipadPage/softwareAgreement/components/softwareAgreement'], resolve)
const SoftwareAgreementHw = resolve => require(['@comp/ipadPage/softwareAgreement/components/softwareAgreementHw'], resolve)
const FoodSafety = resolve => require(['@comp/ipadPage/foodsafety/components/foodsafety'], resolve)
const ThousandsQuestionAndAnswer = resolve => require(['@comp/ipadPage/thousandsQuestionAndAnswer/components/thousandsQuestionAndAnswer'], resolve)
const MyLaobi = resolve => require(['@comp/ipadPage/myLaobi/components/myLaobi'], resolve)
const MyCardCoupon = resolve => require(['@comp/ipadPage/myCardCoupon/components/myCardCoupon'], resolve)
const BrandConcept = resolve => require(['@comp/ipadPage/brandConcept/components/brandConcept'], resolve)
const SpecialService = resolve => require(['@comp/ipadPage/specialService/components/specialService'], resolve)
const MemberBenefits = resolve => require(['@comp/ipadPage/memberBenefits/components/memberBenefits'], resolve)
const JumpJD = resolve => require(['@comp/ipadPage/jumpJD/components/jumpJD'], resolve)
const MyCouponOverseas = resolve => require(['@comp/ipadPage/myCouponOverseas/components/myCouponOverseas'], resolve)
const DishDiffPrice = resolve => require(['@comp/ipadPage/dishDiffPrice/components/dishDiffPrice'], resolve)

/** 营销活动ipad通知详情 */
const IpadActivitiesNotice = resolve => require(['@comp/ipadPage/ipadActivitiesNotice/components/ipadActivitiesNotice'], resolve)

/* ********营业报表开始******** */
// import Home from '@comp/statement/home'
const Home = resolve => require(['@comp/statement/home'], resolve)
const businessTotalTable = resolve => require(['@comp/statement/businessTotalTable-shop/components/businessTotalTable'], resolve)
const AccountReport = resolve => require(['@comp/statement/reportMgr/accountReport-shop/components/accountReport'], resolve)
const eveningTable = resolve => require(['@comp/statement/eveningTable-shop/components/eveningTable'], resolve)
const operatorPriceReport = resolve => require(['@comp/statement/operatorPriceReport-shop/components/operatorPriceReport'], resolve)
const cashierReport = resolve => require(['@comp/statement/cashierReport-shop/components/cashierReport'], resolve)
const saleProceedsReport = resolve => require(['@comp/statement/saleDishPotReport-shop/components/saleProceedsReport'], resolve)
const FreeSingleReport = resolve => require(['@comp/statement/freeSingleReport-shop/components/freeSingleReport'], resolve)
const DishSaleReport = resolve => require(['@comp/statement/dishSaleReport-shop/components/dishSaleReport'], resolve)
const AntiBillReport = resolve => require(['@comp/statement/antiBillReport-shop/components/antiBillReport'], resolve)
const RetreatReport = resolve => require(['@comp/statement/retreatReport-shop/components/retreatReport'], resolve)
const DishGiftReport = resolve => require(['@comp/statement/dishGiftReport-shop/components/dishGiftReport'], resolve)
const DelayedExport = resolve => require(['@comp/statement/delayedExport/components/delayedExport'], resolve)
const TimeDishSelling = resolve => require(['@comp/statement/timeDishSelling/components/timeDishSelling'], resolve)
const DataPush = resolve => require(['@comp/statement/dataPush/components/dataPush'], resolve)
const VoucherWriteOff = resolve => require(['@comp/statement/voucherWriteOff/components/voucherWriteOff'], resolve)
const cashierVoucherReport = resolve => require(['@comp/statement/cashierVoucherReport-shop/components/cashierVoucherReport'], resolve)
// import businessTotalTable from '@comp/statement/businessTotalTable-shop/components/businessTotalTable'
// import AccountReport from '@comp/statement/reportMgr/accountReport-shop/components/accountReport'
// import eveningTable from '@comp/statement/eveningTable-shop/components/eveningTable'
// import operatorPriceReport from '@comp/statement/operatorPriceReport-shop/components/operatorPriceReport'
// import cashierReport from '@comp/statement/cashierReport-shop/components/cashierReport'
// import saleProceedsReport from '@comp/statement/saleDishPotReport-shop/components/saleProceedsReport'
// import FreeSingleReport from '@comp/statement/freeSingleReport-shop/components/freeSingleReport'
// import DishSaleReport from '@comp/statement/dishSaleReport-shop/components/dishSaleReport'
// import AntiBillReport from '@comp/statement/antiBillReport-shop/components/antiBillReport'
// import RetreatReport from '@comp/statement/retreatReport-shop/components/retreatReport'
// import DishGiftReport from '@comp/statement/dishGiftReport-shop/components/dishGiftReport'
/* ********营业报表结束******** */

/**
 * 活动专区
 * @description: 
 * @param {type} 
 * @return: 
 */
const activityZone = resolve => require(['@comp/service/components/activityZone.vue'], resolve)

/**
 * 新加坡优惠活动
 * @description: 
 * @param {type} 
 * @return: 
 */
const specialOffer = resolve => require(['@comp/ipadPage/specialOffer/components/specialOffer.vue'], resolve)
const specialOfferView = resolve => require(['@comp/ipadPage/specialOffer/components/specialOfferView.vue'], resolve)

/**
 * 国内pad优惠活动
 * @description: 
 * @param {type} 
 * @return: 
 */
const activityZoneForPad = resolve => require(['@comp/service/components/activityZoneForPad.vue'], resolve)
const activityZoneForPadView = resolve => require(['@comp/service/components/activityZoneForPadView.vue'], resolve)

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/index',
    name: 'index',
    redirect: '/history',
    component: TasteIndex,
    meta: {
      title: '私人定制'
    },
    children: [{
      path: '/customization',
      name: 'customization',
      component: Customization,
      meta: {
        title: '私人定制'
      }
    },
    {
      path: '/customizationNew',
      name: 'customizationNew',
      component: CustomizationNew,
      meta: {
        title: '私人定制'
      }
    },
    {
      path: '/history',
      name: 'history',
      component: History,
      meta: {
        title: '历史锅底'
      }
    },
    ]
  },
  {
    path: '/QRCode',
    name: 'QRCode',
    component: QRCode,
    meta: {
      title: '扫一扫'
    }
  },
  {
    path: '/shareSelect',
    name: 'shareSelect',
    component: ShareSelect,
    meta: {
      title: '选择要命名的口味'
    }
  },
  {
    path: '/shareSelectNew',
    name: 'shareSelectNew',
    component: ShareSelectNew,
    meta: {
      title: '选择要命名的口味'
    }
  },
  {
    path: '/shareSelect_new',
    name: 'shareSelect_new',
    component: ShareSelect_new,
    meta: {
      title: '选择要命名的口味'
    }
  },
  {
    path: '/share_detail',
    name: 'share_detail',
    component: Share_detail,
    meta: {
      title: '分享详情'
    }
  },
  {
    path: '/share_middle',
    name: 'share_middle',
    component:Share_middle,
    meta: {
      title: '分享详情'
    }
  },
  {
    path: '/beforeShare',
    name: 'beforeShare',
    component: beforeShare,
    meta: {
      title: '海底捞分享'
    }
  },
  {
    path: '/share',
    name: 'share',
    component: Share,
    meta: {
      title: '私人定制'
    }
  },
  {
    path: '/editor',
    name: 'editor',
    component: Editor,
    meta: {
      title: '口味命名'
    }
  },
  {
    path: '/collect',
    name: 'collect',
    component: Collect,
    meta: {
      title: '私人定制'
    }
  },
  {
    path: '/introduce',
    name: 'introduce',
    component: Introduce,
    meta: {
      title: '私人定制'
    }
  },
  {
    path: '/historyDiscount',
    name: 'historyDiscount',
    component: HistoryDiscount,
    meta: {
      title: '历史折扣'
    }
  },
  {
    path: '/temporaryPromotion',
    name: 'temporaryPromotion',
    component: TemporaryPromotion,
    meta: {
      title: '促销信息'
    }
  },
  {
    path: '/announcement',
    name: 'announcement',
    component: Announcement,
    meta: {
      title: '预付卡章程'
    }
  },
  {
    path: '/memberNotice',
    name: 'memberNotice',
    component: MemberNotice,
    meta: {
      title: '会员须知'
    }
  },
  {
    path: '/memberNoticeNew',
    name: 'memberNoticeNew',
    component: MemberNoticeNew,
    meta: {
      title: '会员须知'
    }
  },
  {
    path: '/memberNoticeNew',
    name: 'memberNoticeNew',
    component: MemberNoticeNew,
    meta: {
      title: '会员须知'
    }
  },
  { // 新会员须知海外
    path: '/memberNoticeNewHw',
    name: 'memberNoticeNewHw',
    component: MemberNoticeNewHw,
    meta: {
      title: '会员须知'
    }
  },
  {
    path: '/privacyPolicy',
    name: 'privacyPolicy',
    component: PrivacyPolicy,
    meta: {
      title: '隐私政策'
    }
  },
  {
    path: '/privacyPolicyNew',
    name: 'privacyPolicyNew',
    component: PrivacyPolicyNew,
    meta: {
      title: '隐私政策'
    }
  },
  {
    path: '/privacyPolicyNewHw',
    name: 'privacyPolicyNewHw',
    component: PrivacyPolicyNewHw,
    meta: {
      title: '隐私政策'
    }
  },
  {
    path: '/softwareAgreement',
    name: 'softwareAgreement',
    component: SoftwareAgreement,
    meta: {
      title: '软件使用协议'
    }
  },
  {
    path: '/softwareAgreementHw',
    name: 'softwareAgreementHw',
    component: SoftwareAgreementHw,
    meta: {
      title: '软件使用协议'
    }
  },
  {
    path: '/foodsafety',
    name: 'foodsafety',
    component: FoodSafety,
    meta: {
      title: '食品安全'
    }
  },
  {
    path: '/thousandsQuestionAndAnswer',
    name: 'thousandsQuestionAndAnswer',
    component: ThousandsQuestionAndAnswer,
    meta: {
      title: '千人千味问答'
    }
  },
  {
    path: '/myLaobi',
    name: 'myLaobi',
    component: MyLaobi,
    meta: {
      title: '我的捞币'
    }
  },
  {
    path: '/ipadActivitiesNotice',
    name: 'ipadActivitiesNotice',
    component: IpadActivitiesNotice,
    meta: {
      title: '活动详情'
    }
  },
  {
    path: '/myCardCoupon',
    name: 'myCardCoupon',
    component: MyCardCoupon,
    meta: {
      title: '我的卡券'
    }
  },
  {
    path: '/brandConcept',
    name: 'brandConcept',
    component: BrandConcept,
    meta: {
      title: '品牌理念'
    }
  },
  {
    path: '/specialService',
    name: 'specialService',
    component: SpecialService,
    meta: {
      title: '特色服务'
    }
  },
  {
    path: '/memberBenefits',
    name: 'memberBenefits',
    component: MemberBenefits,
    meta: {
      title: '会员权益'
    }
  },
  {
    path: '/jumpJD',
    name: 'jumpJD',
    component: JumpJD,
    meta: {
      title: '跳转中'
    }
  },
  {
    path: '/myCouponOverseas',
    name: 'm',
    component: MyCouponOverseas,
    meta: {
      title: '我的卡券海外'
    }
  },
  {
    path: '/dishDiffPrice',
    name: 'dishDiffPrice',
    component: DishDiffPrice,
    meta: {
      title: '通知'
    }
  },
  {
    path: '/home',
    name: 'home',
    redirect: '/home/businessTotalTable',
    component: Home,
    mate: {
      title: '营业报表'
    },
    children: [{
      path: 'businessTotalTable',
      component: businessTotalTable,
      meta: {
        title: '营业汇总表'
      }
    },
    {
      path: 'accountReport',
      component: AccountReport,
      meta: {
        title: '账单流水表'
      }
    },
    {
      path: 'eveningTable',
      component: eveningTable,
      meta: {
        title: '深夜班桌数'
      }
    },
    {
      path: 'operatorPriceReport',
      component: operatorPriceReport,
      meta: {
        title: '计件工资'
      }
    },
    {
      path: 'cashierReport',
      component: cashierReport,
      meta: {
        title: '收款员销售报表'
      }
    },
    {
      path: 'saleProceedsReport',
      component: saleProceedsReport,
      meta: {
        title: '菜品销售报表'
      }
    },
    {
      path: 'freeSingleReport',
      component: FreeSingleReport,
      meta: {
        title: '免单查询'
      }
    },
    {
      path: 'dishSaleReport',
      component: DishSaleReport,
      meta: {
        title: '打折查询'
      }
    },
    {
      path: 'antiBillReport',
      component: AntiBillReport,
      meta: {
        title: '打折查询'
      }
    },
    {
      path: 'retreatReport',
      component: RetreatReport,
      name: 'retreatReport',
      meta: {
        title: '退菜查询'
      }
    },
    {
      path: 'dishGiftReport',
      component: DishGiftReport,
      name: 'dishGiftReport',
      meta: {
        title: '退菜查询'
      }
    },
    {
      path: 'delayedExport',
      component: DelayedExport,
      name: 'delayedExport',
      meta: {
        title: '延迟下载'
      }
    },
    {
      path: 'timeDishSelling',
      component: TimeDishSelling,
      name: 'timeDishSelling',
      meta: {
        title: '分时段销售菜品'
      }
    },
    {
      path: 'dataPush',
      component: DataPush,
      name: 'dataPush',
      meta: {
        title: '数据推送'
      }
    },
    {
      path: 'voucherWriteOff',
      component: VoucherWriteOff,
      name: 'voucherWriteOff',
      meta: {
        title: '数据推送'
      }
    },
    {
      path: 'cashierVoucherReport',
      component: cashierVoucherReport,
      meta: {
        title: '收款员收款凭证报表'
      }
    },
    ]
  },
  {
    path: '/activityZone',
    name: 'activityZone',
    component: activityZone,
    meta: {
      title: '活动专区'
    }
  },
  {
    path: '/activityZoneForPad',
    name: 'activityZoneForPad',
    component: activityZoneForPad,
  }, {
    path: '/activityZoneForPadView',
    name: 'activityZoneForPadView',
    component: activityZoneForPadView,
  },
  {
    path: '/specialOffer',
    name: 'specialOffer',
    component: specialOffer,
    // meta{
    //   title
    // }
  },
  {
    path: '/specialOfferView',
    name: 'specialOfferView',
    component: specialOfferView,
  }
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js